import { Injectable } from '@angular/core';

import {ParagraphNavigationWidgetItemData, ParagraphNavigationWidgetData, ParagraphLogoSliderData,ParagraphSmallColumnModuleData, MultipleColumnItemDataInner, ParagraphMultipleColumnData, ParagraphMultipleColumnItemData } from '@generated/content';
import {
  NavigationWidgetItem,
  MediaImageData,
  NavigationWidgetItemDataInner

} from '@generated/content';
import { TMediaNodeType } from '@interfaces/media';

import { CmsComponentNodeData } from '@interfaces/cms-component-node-data';
import { LogoSlider } from '@interfaces/config/cms-components/sliders/logo-slider-config';

import { NavigationWidget } from '@interfaces/config/cms-components/navigation-widget-config';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';

import {  CmsComponentTypeEnum, MediaTypesEnum } from '@models/enums';
import { CmsComponentConfig, TextMediaBox } from '@interfaces/config';

import { MediaResolver } from '@services/resolvers/auxiliary/media-resolver';


@Injectable({ providedIn: 'root' })
export class NavigationWidgetComponentResolver extends BaseComponentResolver {
  static override instance: NavigationWidgetComponentResolver;
  private readonly componentType = NavigationWidget.TypeEnum;

  static getInstance(): NavigationWidgetComponentResolver {
 
    return (NavigationWidgetComponentResolver.instance ||= new NavigationWidgetComponentResolver());
  }

  public override resolveComponentConfig(
    node: ParagraphNavigationWidgetData,
    nodePageData: CmsComponentNodeData[]
  ): CmsComponentConfig<NavigationWidget.ComponentConfig> | null {

      
  


    if (!node) {
      return null;
    }

 

    this.nodePageData = nodePageData;
     


     
   
   return {
      componentType: this.componentType,
      config: {
        nodeId: BaseComponentResolver.getNodeId(node),
        anchor_id : "",
        anchors:this.getColumns(node)
   
        
      },
    };


    
  }




  private getColumns(node: ParagraphNavigationWidgetData):  any {



    if (!node.relationships.field_navigation_widget_items?.data?.length) {
      return [];
    }
    

     return node.relationships.field_navigation_widget_items.data.map(item => this.buildColumnConfig(item));
  }

       
   private buildColumnConfig(node: NavigationWidgetItemDataInner): {anchor_id:string,anchor_name:string} | null {
     const { id, type } = node;
 
     if (!(id && node)) {
       return null;
     }

      const columnNode = this.getNode<ParagraphNavigationWidgetItemData>(id, type);
   
     return {anchor_id: columnNode.attributes.field_navigation_anchor_id,anchor_name:columnNode.attributes.field_navigation_item_name};
    }



    
 

    


}
